// extracted by mini-css-extract-plugin
export var rightPanelOpenOld = "_a5-0";